import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'react-bootstrap';
import Modal from "react-modal";
import './styles.css';
import {
    MobileBackButton,
    MobileInputContainer,
    MobileButton,
    LoadingMask
} from '../../../../Shared';
import {
    deleteDeliveryAddress,
    deletePhoneNumber,
    saveAndVerifyDeliveryMethod,
    addDeliveryMethod,
    addPhoneNumber,
    addCurrentOperatingValue,
} from "../../../../actions/actions";
import { Texts } from './textConfig';
import _ from 'lodash';
import {
    addEmailAddress,
    saveVerifyEmailAddress,
    AddPhoneNumberContent,
    SaveVerifyPhoneNumber,
    validateEmail,
    validatePhone,
} from '../../../../helpers/utils';
import { LoadingState } from '../../../../helpers/enum';
import { NotificationManager } from 'react-notifications';

class EditPage extends Component {
    constructor(props) {
        super(props);

        const {
            match: {
                params
            },
            deliveryAddresses = [],
        } = props;

        let editableItem = {
            address: params.type === 'email' ? '' : '1'
        };
        if (params.id) {
            editableItem = deliveryAddresses.filter(item => item.id === params.id)[0];
        }
        if (!editableItem) {

        }
        else {
            this.initialValue = editableItem.address || ""
            this.state = {
                editableItem,
                value: editableItem.address || "",
                valid: params.type === 'email' ?
                validateEmail( this.initialValue) :
                validatePhone( this.initialValue),
                showDeletePopup : false
            }

        }
    };

    changeHandler = e => {
        const {
            match: {
                params
            },
        } = this.props;
        this.setState({
            value: e.target.value,
            valid: params.type === 'email' ?
                validateEmail(e.target.value) :
                validatePhone(e.target.value)
        });
    }

    delete = () => {
        const {
            deleteDeliveryAddress,
            deletePhoneNumber,
            history,
            match: {
                params
            },
        } = this.props;
        const {
            areaCode, phoneNumber, countryCode
        } = this.state.editableItem;
        if (params.type === 'email') {
            deleteDeliveryAddress({
                deliveryAddress: this.state.value,
                id: params.id,

            }).then(() => {
                history.goBack();
            });
        } else {
            deletePhoneNumber({
                countryCode,
                areaCode,
                id: params.id,
                phoneNumber,
            }).then(() => {
                history.goBack();
            });
        }
    }

    updateOrSave = () => {
        const {
            match: {
                params
            },
            history,
            addDeliveryMethod,
            saveAndVerifyDeliveryMethod,
            addPhoneNumber,
            addCurrentOperatingValue,
        } = this.props;


        const { value, editableItem, valid } = this.state;
        if (!valid) return;

        addCurrentOperatingValue(value)
        if (params.type === 'email') {
            if (params.id) {
                saveAndVerifyDeliveryMethod(
                    saveVerifyEmailAddress(value, params.id)
                ).then(response => {
                    if (response) {
                        history.push("/verifyEmailOrPhone/email/" + params.id);
                    }
                });
            } else {
                addDeliveryMethod(
                    addEmailAddress(value)
                ).then(response => {
                    if (response) {
                        history.push("/verifyEmailOrPhone/email/" + response.id);
                    }
                });

            }
        } else {
            if (params.id) {
                saveAndVerifyDeliveryMethod(
                    SaveVerifyPhoneNumber(value, editableItem)
                ).then(response => {
                    if (response) {
                        history.push("/verifyEmailOrPhone/phone/" + params.id);
                    }
                });
            } else {
                addPhoneNumber(
                    AddPhoneNumberContent(value)
                ).then(response => {
                    if (response) {
                        history.push("/verifyEmailOrPhone/phone/" + response.id);
                    }
                });
            }
        }

    }

    getTexts = params => {
        if (params.id) {
            if (params.type === 'email') {
                return Texts.editEmail;
            }
            return Texts.editPhone;
        } else {
            if (params.type === 'email') {
                return Texts.newEmail;
            }
            return Texts.newPhone;
        }
    }

    componentDidMount() {
        if (!this.state.editableItem) {
            this.props.history.push("/alertPreferences/addOrEditMethodComponent")
        }
    }

    componentDidUpdate(){
        setTimeout(() => {
        var root = document.getElementById("root");
       
        var _event = {};
    
        _event = {
        name: 'END_SETTING_HEIGHT',
        height: root.parentElement.parentElement.offsetHeight
    };
    
      //Post END Height Event for OLB 
        window.parent.postMessage(_event, '*')
        }, 
      0)    
    };
    

    renderDeleteConfirmation() {
        
    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: '90%',
          minWidth: '50%',
          padding: '2%'
        }
      };
                return (   <Modal
                    style={customStyles}
                    ariaHideApp={false}
                    isOpen={this.state.showDeletePopup}
                    onRequestClose={() => {
                      this.setState({ showDeletePopup: false });
                    }}
                    contentLabel="Example Modal"
                  >
                    <div className="Row">
                      <div className="Col" md="12">
                        Are you sure you want to delete  {this.state.value}? 
                      </div>
                    </div>
                    <hr></hr>
                    <div className="Row">
                      <div className="Col alignDeletePopUp" md="12">
      
                        <Button
                          variant="Link"
                          className="AppLink colleftalign"
                          onClick={() => {
                            this.setState({
                                showDeletePopup: false
                            });
                          }}
                        >
                          Cancel
                      </Button>
                        <Button
                          className="colrightalign custom-buttonForDeletePopUp"
                          onClick={() => {
                               this.setState({
                                showDeletePopup: false
                            });
                            this.delete();
                          }}
                        >
                          Continue
                      </Button>
                      </div>
                    </div>
                  </Modal>)
    }

    render() {

        if (!this.state.editableItem) {
            return null;
        }
        const {
            match: {
                params
            },
        } = this.props;
        const { value, valid } = this.state;
        let texts = this.getTexts(params);
        let errorMessage;
        let addressType;
        if (params.type === 'email') {
            errorMessage = 'Please enter valid Email Address'
            addressType = 'email address'
        }
        else {
            errorMessage = 'Please enter valid Phone number'
            addressType = 'phone number'
        }


        return (
            <div>
                {this.renderDeleteConfirmation()}
                  <div aria-live="polite">
                {this.props.deliveryMethodState === LoadingState.PENDING && <LoadingMask ctrlCss="overlay" />}
</div>
                <div className="mobilecontainer-box mobile-edit mobile-padding-right">
                    <MobileBackButton
                        href={'#/alertPreferences/addOrEditMethodComponent'}
                    />
                    <div className="header">
                        <h2 className="header-heading">
                            {texts.mainHeaderText}
                        </h2>
                        <div className="header-description italic">
                            To ensure your account security, a One-Time Code will be sent to the {addressType} provided.
                            
                    </div>
                    </div>
                    <MobileInputContainer
                        inputLabel={texts.inputLabelText}
                        inputValue={value || ""}
                        validationMessage={errorMessage}
                        showValidation={valid}
                        changeHandler={(e) => this.changeHandler(e)}
                        needMask={params.type !== "email"}
                        maskValue={params.type !== "email" ? "9-999-999-9999" : " "}
                    />
                    <div className="button-block-dock-bottom">
                        {params.id &&
                            <MobileButton
                            id="deletebutton"
                                whichbutton='delete'
                                buttontext={texts.deleteText}
                                callbackHandler={() => {
                                    this.setState({
                                        showDeletePopup: true
                                    })
                                }}
                            />
                        }
                        <MobileButton
                            whichbutton='new'
                            id="savebutton"
                            buttontext={texts.buttonSaveText}
                            callbackHandler={() =>{
                                if(!valid){
                                    NotificationManager.error("invalid "+ params.type)
                                    return;

                                }else if (this.initialValue === this.state.value) {
                                    NotificationManager.error(params.type+ " not changed ");
                                    return;
                                }
                                this.updateOrSave()}}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const deliveryAddresses = _.get(state, 'accountAlertsReducer.items.deliveryMethods');
    return {
        deliveryAddresses,
        deliveryMethodState: state.accountAlertsReducer.deliveryMethodState,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            deleteDeliveryAddress,
            deletePhoneNumber,
            addDeliveryMethod,
            saveAndVerifyDeliveryMethod,
            addPhoneNumber,
            addCurrentOperatingValue,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPage);
